//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {provide as RegistrableProvide} from "../../mixins/Registrable";
import Swiper from 'swiper';
const Btn = () => import('../Button/Btn');
const Icon = () => import('../Icon/Icon');

export default {
    name: 'Slider',

    mixins: [RegistrableProvide('slider')],

    components: {Btn, Icon},

    props: {
        // The value of the active item(s) to display
        value: {
            default: null
        },

        // Whether to disable a slide change by touch movements
        disableTouch: {
            type: Boolean,
            default: false
        },

        // Whether navigation dots shall be displayed
        showPagination: {
            type: Boolean,
            default: false
        },

        // Whether navigation arrows shall be displayed
        showArrows: {
            type: Boolean,
            default: false
        },

        // Whether enable navigation via keyboard
        withKeyboardNavigation: {
            type: Boolean,
            default: false
        },

        // Whether navigation arrows shall always be visible
        // Otherwise they are only visible on hover for desktop devices
        visibleArrows: {
            type: Boolean,
            default: false
        },

        // Whether to adapt the height of the slider to the current slide's height
        // Only works when no dynamic content is added on the active slide
        autoHeight: {
            type: Boolean,
            default: false
        },

        // The transition speed
        speed: {
            type: [Number, String],
            default: 300
        },

        // The ms after which the slides shall automatically change
        nextAfter: {
            type: [Number, Boolean],
            default: false
        },

        // Whether to start the slider from the beginning when the end is reached
        loop: {
            type: Boolean,
            default: false
        },

        // Number of slides per view (slides visible at the same time on slider's container).
        slidesPerView: {
            type: [Number, String],
            default: 1
        },

        // If true, then active slide will be centered, not always on the left side.
        centered: {
            type: Boolean,
            default: false
        },

        // Distance between slides in px.
        space: {
            type: [Number, String],
            default: 0
        },
    },

    data() {
        return {
            slider: null,
            slides: [],
            activeSlideValue: this.value,
            activeSlideViewIndex: 0,
            autoChangeInterval: null,

            isLastSlide: false
        }
    },

    computed: {
        isFirstSlide() {
            return this.activeSlideViewIndex === 0
        },

        slideViews() {
            return !isNaN(this.slidesPerView) ? Math.ceil(this.slides.length / this.slidesPerView) : this.slides.length
        }
    },

    watch: {
        value(value) {
            this.activeSlideValue = value;
        },

        activeSlideValue(value) {
            this.$emit('input', value)
            this.activeSlideViewIndex = this.getIndexForValue(value)
        },

        activeSlideViewIndex(value) {
            // On init there might be no slides yet, whereby we do not want to override the initial activeSlideValue with null
            if (this.slides && this.slides.length) {
                let activeSlide = this.slides[value];
                this.activeSlideValue = activeSlide ? activeSlide.value : null;
            }

            this.slider.slideTo(value)
            if (this.autoHeight) {
                setTimeout(() => {
                    this.slider.update(); // Updates the active slide's height
                }, parseInt(this.speed));
            }
        },

        nextAfter: {
            handler(interval) {
                if (!interval) {
                    this.clearAutoChange();
                } else {
                    this.setAutoChange(interval);
                }
            },
            immediate: true
        }
    },

    mounted() {
        this.$nextTick(function () {
            this.activeSlideViewIndex = this.getIndexForValue(this.activeSlideValue)
            this.slider = new Swiper(this.$el, {
                slidesPerView: this.slidesPerView,
                initialSlide: this.activeSlideViewIndex,
                allowTouchMove: !this.disableTouch,
                autoHeight: this.autoHeight,
                centeredSlides: this.centered,
                spaceBetween: this.space,
                speed: parseInt(this.speed),
                keyboard: {
                    enabled: this.withKeyboardNavigation
                }
            });

            this.slider.on('slideChange', () => {
                // Keep the component props in sync when slide is changed via the Swiper API
                this.activeSlideViewIndex = this.slider.activeIndex;

                if (this.isLastSlide) {
                    this.isLastSlide = false;
                }
            });

            this.slider.on('reachEnd', () => {
                // nexttick to set prop after slideChange event which would unset the prop otherwise
                this.$nextTick(function () {
                    this.isLastSlide = true;
                });
            });
        });
    },

    beforeDestroy() {
        this.clearAutoChange();
        if (this.slider) {
            this.slider.destroy();
        }
    },

    methods: {

        setAutoChange(interval) {
            this.clearAutoChange();
            this.autoChangeInterval = setInterval(() => {
                this.slideNext(false);
            }, interval)
        },

        clearAutoChange() {
            if (this.autoChangeInterval) {
                clearInterval(this.autoChangeInterval);
            }
        },

        getIndexForValue(value) {
            let index = this.slides.findIndex(i => i.value === value)
            if (index < 0 && !isNaN(value)) {
                return value ? value : 0;
            }
            return index;
        },

        slidePrev(triggeredByUser = true) {
            // If the user clicked the prev button manually, we stop the auto slide change for better UX
            if (triggeredByUser) {
                this.clearAutoChange();
            }

            if (!this.isFirstSlide) {
                this.activeSlideViewIndex--;
            } else if (this.loop) {
                this.activeSlideViewIndex = this.slideViews - 1;
            }
        },

        slideNext(triggeredByUser = true) {
            // If the user clicked the next button manually, we stop the auto slide change for better UX
            if (triggeredByUser) {
                this.clearAutoChange();
            }
            if (!this.isLastSlide) {
                this.activeSlideViewIndex++;
            } else if (this.loop) {
                this.activeSlideViewIndex = 0;
            }
        },

        slideTo(slideViewIndex, triggeredByUser = true) {
            // If the user clicked the button manually, we stop the auto slide change for better UX
            if (triggeredByUser) {
                this.clearAutoChange();
            }
            this.activeSlideViewIndex = slideViewIndex;
        },

        updateSlider() {
            if (this.slider) {
                this.slider.update();
            }
        },

        register(item) {
            this.slides.push(item)
            setTimeout(() => {
                this.updateSlider();
            }, 0); // Wait for slide to be rendered on the DOM
        },

        unregister(item) {
            const found = this.slides.find(i => i._uid === item._uid)
            if (!found) return

            this.slides = this.slides.filter(i => i._uid !== found._uid)
            setTimeout(() => {
                this.updateSlider();
            }, 0); // Wait for slide to be removed on the DOM
        },
    }

}
